<template>
  <div id="app" :class="{ 'signedin': $store.getters.isAuthenticated }">
    <the-nav-bar></the-nav-bar>
    <transition name="fade" mode="out-in" >
      <router-view  class="mt-70-px"></router-view>
    </transition>
    <the-footer></the-footer>
  </div>
</template>

<script>
import LogoText from "raw-loader!./assets/intelligencecompany.txt";
import TheNavBar from '@/components/TheNavBar';
import TheFooter from '@/components/TheFooter';

export default {
  name: 'app',
  components: {
    'the-nav-bar': TheNavBar,
    'the-footer': TheFooter
  },
  metaInfo() {
      return {
          title: 'Azurity Beveiliging',
          titleTemplate: this.$route.meta.title + ' | %s',
          link: [
              { rel: 'canonical', href: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href }
          ],
          htmlAttrs: {
              lang: 'nl',
              //amp: true
          },
          meta: [
              { name: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Azurity is een beveiligingsbedrijf voor het inhuren van beveiliging, verkeersregelaar en EHBO professionals. Gevestigd in Oegstgeest en Leiden.' },
              { name: 'keywords', content: (!!this.$route.meta.keywords) ? this.$route.meta.keywords : 'Beveiliging, Beveiliger, Security, Inhuren, Freelance, Beveiligingsopdracht, Beveiligingsbedrijf, Huur, Vraag, Aanbod, Objectbeveiliger, Winkelsurveillance, Evenementenbeveiliger, Receptionist, Persoonsbeveiliger, Brandwacht, Verkeersregelaar, EHBO, Leiden, Oegstgeest' },
              
              { property: 'og:title', content: 'Azurity Beveiliging ← ' + this.$route.meta.title },
              { property: 'og:site_name', content: 'Azurity Beveiliging'},
              { property: 'og:type', content: 'website'},
              { property: 'og:url', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { property: 'og:image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://azurity.nl/img/beveiliger-600.a9585756.png' },
              { property: 'og:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Azurity is een beveiligingsbedrijf voor het inhuren van beveiliging, verkeersregelaar en EHBO professionals. Gevestigd in Oegstgeest en Leiden.'},

              { name: 'twitter:card', content: 'summary'},
              { name: 'twitter:site', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { name: 'twitter:title', content: 'Azurity Beveiliging ← ' + this.$route.meta.title},
              { name: 'twitter:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Azurity is een beveiligingsbedrijf voor het inhuren van beveiliging, verkeersregelaar en EHBO professionals. Gevestigd in Oegstgeest en Leiden.'},
              { name: 'twitter:creator', content: 'info@azurity.nl'},
              { name: 'twitter:image:src', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://azurity.nl/img/beveiliger-600.a9585756.png' },

              { itemprop: 'name', content: 'Azurity Beveiliging ← ' + this.$route.meta.title},
              { itemprop: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Azurity is een beveiligingsbedrijf voor het inhuren van beveiliging, verkeersregelaar en EHBO professionals. Gevestigd in Oegstgeest en Leiden.'},
              { itemprop: 'image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://azurity.nl/img/beveiliger-600.a9585756.png' }

          ]
      }
  },
  created() {
    return console.log(LogoText);
  },
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "@/assets/scss/buttons.scss";
@import "@/assets/scss/links.scss";
@import "@/assets/scss/transitions.scss";
@import "@/assets/scss/forms.scss";


html {
  height: 100%;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: 'Ubuntu', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  position: relative;
  margin: 0;
  min-height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $textColor;
  min-height: 100%;
  padding-bottom: 482px;
  transition: padding-bottom 0.5s ease-out;
  overflow: hidden;
}

#app.signedin
{
  padding-bottom: 200px;
  transition: padding-bottom 0.5s ease-out;
}

.mt-70-px {
  margin-top: 70px;
}

.page {
  min-height: 450px;
}

.red {
  color: red;
}

.uppercase {
  text-transform: uppercase;
}

hr{
  border-color: $lightColor
}

.nowrap {
    white-space:nowrap;
}

.ellipsis {
    width: 100%;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}

.vert-center {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.text-center.vert-center {
  justify-content: center;
}

.inline {
    display: inline-block;
}
.right {
    float: right;
}

.v-enter-active, .v-leave-active {
  transition: opacity .3s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

.down {
    position:relative;
    height:100% !important;
    width:100% !important;
}
.down:after {
    content:'';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -30px;
    width: 0;
    height: 0;
    border-top: solid 30px $primaryColor;
    border-left: solid 30px transparent;
    border-right: solid 30px transparent;
}
.down.white:after
{
  border-top: solid 30px #fff;
}
.down.light:after
{
  border-top: solid 30px $lightColor;
}
.down.dark:after
{
  border-top: solid 30px $darkColor;
}

.zIndexOne {
    z-index: 1;
}

.zIndexTwo {
    z-index: 2;
}

.zIndexThree {
    z-index: 3;
}
/*
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: $lightColor;
    color: $darkColor;
    border-radius: 3px;
    border: 1px solid $darkColor;
    padding: 5px 10px 4px;
    text-align: left;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: $darkColor;
  }



  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}

  */
.thead-azure-dark
{
  th {
    background-color: $darkColor;
    border-color: $darkColor !important;
    color: #fff;
  }
}

.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}

@media only screen and (max-width: 768px) {
  .visible-sm {
    visibility: visible;
  }
  .invisible-sm {
    visibility: hidden;
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .visible-md {
    visibility: visible;
  }
  .invisible-md {
    visibility: hidden;
    display: none;
  }
}


</style>
